import axios from '../../axios';

export default {
  namespaced: true,
  state: {
    CarhirePageId: 1180,
    CarhireModules: null,
  },
  getters: {
    getCarhireHtml: (state) => {
      if (state.CarhireModules) {
        // concatenate all the html values for each cms module on the page.
        return state.CarhireModules.modules.map((m) => m.moduleSettings[0].value).join('');
      }
    },
  },
  mutations: {
    setCarhireModules(state, data) {
      state.CarhireModules = data;
    },
  },
  actions: {
    fetchCarhire({
      commit, state, dispatch, getters, rootGetters,
    }) {
      // fetch the cms modules for the booking conditions page by id.
      const path = rootGetters['applinks/getLink']('page', state.CarhirePageId).url;
      axios.get('/cms/pages/modules/bypath', { params: { path } })
        .then((res) => {
          commit('setCarhireModules', res.data);
        });
    },
  },
};
